"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var input_1 = require("./styled/input");

var label_1 = require("./styled/label");

var switch_1 = require("./styled/switch");

var Toggle = function Toggle(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      className = _a.className,
      id = _a.id,
      name = _a.name,
      label = _a.label,
      onChange = _a.onChange,
      _b = _a.sizeOption,
      sizeOption = _b === void 0 ? 'small' : _b,
      isToggled = _a.isToggled,
      isDisabled = _a.isDisabled,
      isInverse = _a.isInverse;

  var _c = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Toggle',
    className: className,
    __UIScope: __UIScope
  }),
      makeClasses = _c.makeClasses,
      rootClasses = _c.rootClasses;

  var toggleId = (0, use_id_1.useId)(id);
  var labelColor = (0, react_1.useMemo)(function () {
    if (isDisabled) return isInverse ? 'grey-400' : 'grey-medium';
    return isInverse ? 'grey-white' : 'grey-dark';
  }, [isDisabled, isInverse]);
  return react_1.default.createElement(label_1.Label, {
    className: rootClasses,
    "data-testid": testID,
    htmlFor: toggleId,
    element: "label",
    pattern: "body",
    color: labelColor,
    isInverse: isInverse,
    isDisabled: isDisabled
  }, react_1.default.createElement(input_1.Input, {
    className: makeClasses('Input'),
    type: "checkbox",
    onChange: onChange,
    checked: isToggled,
    sizeOption: sizeOption,
    id: toggleId,
    name: name,
    disabled: isDisabled
  }), react_1.default.createElement(switch_1.Switch, {
    sizeOption: sizeOption
  }), label);
};

var ToggleWithSpace = (0, ui_helper_with_space_1.withSpace)(Toggle);
exports.Toggle = ToggleWithSpace;